<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="21"
    viewBox="0 0 25 21"
    fill="none"
  >
    <path
      d="M14.6635 9.64509C14.6635 11.0659 13.5802 12.1495 12.3259 12.1495C11.0716 12.1495 9.98828 11.0659 9.98828 9.64509C9.98828 8.22423 11.0716 7.14062 12.3259 7.14062C13.5802 7.14062 14.6635 8.22423 14.6635 9.64509Z"
      stroke-width="1.5"
    />
    <path
      d="M21.5215 7.17936C21.5215 8.20322 20.7225 8.99348 19.7852 8.99348C18.8478 8.99348 18.0488 8.20322 18.0488 7.17936C18.0488 6.1555 18.8478 5.36523 19.7852 5.36523C20.7225 5.36523 21.5215 6.1555 21.5215 7.17936Z"
      stroke-width="1.5"
    />
    <path
      d="M6.60352 7.17936C6.60352 8.20322 5.80452 8.99348 4.86719 8.99348C3.92985 8.99348 3.13086 8.20322 3.13086 7.17936C3.13086 6.1555 3.92985 5.36523 4.86719 5.36523C5.80452 5.36523 6.60352 6.1555 6.60352 7.17936Z"
      stroke-width="1.5"
    />
    <path
      d="M15.7783 19.9998H8.87509C8.33457 19.9998 7.89188 19.5703 7.87554 19.03L7.80876 16.8209C7.80012 16.5351 7.93535 16.264 8.16887 16.099C10.6342 14.3569 13.9516 14.4429 16.3233 16.3105L16.5013 16.4506C16.724 16.626 16.8499 16.8969 16.8404 17.1802L16.7778 19.0335C16.7596 19.5724 16.3175 19.9998 15.7783 19.9998Z"
      stroke-width="1.5"
    />
    <path
      d="M22.1642 14.6154H17.3576C16.9079 14.6154 16.5135 14.3152 16.3938 13.8817L16.1106 12.8569C16.0152 12.5114 16.161 12.1445 16.4677 11.9588C18.4636 10.7504 20.9586 10.7229 22.9807 11.887L23.0728 11.94C23.4097 12.134 23.565 12.5373 23.4451 12.9072L23.1154 13.9238C22.9818 14.3362 22.5976 14.6154 22.1642 14.6154Z"
      stroke-width="1.5"
    />
    <path
      d="M7.34215 14.6154H2.54474C2.12278 14.6154 1.74622 14.3505 1.6036 13.9534L1.23551 12.9285C1.09921 12.549 1.25437 12.1263 1.60386 11.9251L1.70075 11.8693C3.70928 10.713 6.18283 10.7193 8.18549 11.8857C8.49226 12.0644 8.64665 12.4222 8.56616 12.768L8.31611 13.8421C8.21069 14.295 7.80709 14.6154 7.34215 14.6154Z"
      stroke-width="1.5"
    />
    <path
      d="M14.2187 2.56412C14.2187 3.58798 13.4198 4.37824 12.4824 4.37824C11.5451 4.37824 10.7461 3.58798 10.7461 2.56412C10.7461 1.54026 11.5451 0.75 12.4824 0.75C13.4198 0.75 14.2187 1.54026 14.2187 2.56412Z"
      stroke-width="1.5"
    />
  </svg>
</template>
